/** @module SiteAdmin/Config/UpdateConfigurationController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dijit/form/RadioButton",
	"csi/action/Controller",
	"csi/html",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,lang,RadioButton,Controller,html,MessageDialog,xml) {
	var UPDATECONFIGURATION_PARTIAL = "UpdateConfigurationPartial";
	var UPDATECONFIGURATION_FULL = "UpdateConfigurationFull";
	var UPDATECONFIGURATION = "UpdateConfiguration";

	return declare(Controller, {
		/**
		 * @override
		 * Always show the MessagegBox
		*/
		hasToConfirmAction: function() {
			return true;
		},

		_createUpdateOptions: function(divMessage) {
			html.create("div", {class: "csi-form-radio-top"}, divMessage);

			var w = new RadioButton({
				id: UPDATECONFIGURATION_PARTIAL,
				checked: true,
				value: UPDATECONFIGURATION_PARTIAL,
				name: UPDATECONFIGURATION
			});
			w.placeAt(divMessage);
			w.startup();

			html.create("label", {innerText: this.getString("_SetPartial"), for: UPDATECONFIGURATION_PARTIAL, class: "csi-form-radio-label"}, divMessage);
			html.create("label", {
				innerText: this.getString("_DescriptionForPartial"),
				class: "csi-disabled-color csi-form-radio-label-comment",
				for: UPDATECONFIGURATION_PARTIAL
			}, divMessage);
			html.create("div", {class: "csi-form-radio-gap"}, divMessage);

			w = new RadioButton({
				id: UPDATECONFIGURATION_FULL,
				value: UPDATECONFIGURATION_FULL,
				name: UPDATECONFIGURATION
			});
			w.placeAt(divMessage);
			w.startup();
			html.create("label", {innerText: this.getString("_SetFull"), for: UPDATECONFIGURATION_FULL, class: "csi-form-radio-label"}, divMessage);
			html.create("label", {
				innerText: this.getString("_DescriptionForFull"),
				class: "csi-disabled-color csi-form-radio-label-comment",
				for: UPDATECONFIGURATION_FULL
			}, divMessage);

			html.create("div", {class: "csi-form-radio-bottom"}, divMessage);
		},

		/**
		 * @override
		 * Displays a Prompt
		 */
		confirmAction: function(params) {
			params = params || {};
			params.materialIcon = "";
			params.title = this.getString("_Options");
			params.onMessage = lang.hitch(this, this._createUpdateOptions);

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Call the appropriate operation based on user's selection
		 */
		toWriter: function() {
			var selection = this.confirmValues[UPDATECONFIGURATION];
			var w = this.m_writer.callMethod("Reflection", "ScheduleConfigurationUpdate");
			if (selection == UPDATECONFIGURATION_PARTIAL) {
			    w.addParameter("ConfiguratorName", xml.ATTR_STRING, "Export2JS");
			}
		}
	});
});